import { mockUtils } from "../../../development/mocks/mock-utils";
import { globalApiMock } from "../../events-screen/parent-events-mocks/global.api.mock";
import {
  getRandomMemberFromString,
  numberFromString,
} from "../../events-screen/parent-events-mocks/mock-utils-functions";
import { parentEventsMocks } from "../../events-screen/parent-events-mocks/parent-events.mock";
import { BaseDiscountModel } from "../discount-models/BaseDiscountModel";
import {
  ChildDiscountModel,
  ChildDiscountStatus,
} from "../discount-models/ChildDiscountModel";
import { ChildEvent } from "../../events-screen/event-page-models/child-event";

const firstNames = mockUtils.hebFirstNames;

const hebLastNames = mockUtils.hebLastNames;

const citiesAndNests = mockUtils.citiesAndNests;

const streets = [
  "הרצל",
  "התמר",
  "הצבי",
  "טרומפלדור",
  "חיים",
  "מסדה",
  "הגפן",
  "אלון",
];

const nest = globalApiMock.nests.map((n) => n.name);
const layers = globalApiMock.layers.map((l) => l.layerName);
const parentEventMocks = parentEventsMocks.mainMock;

const addLongStringsToBaseDiscountModel = (
  model: BaseDiscountModel
): BaseDiscountModel => {
  const clonedModel = { ...model };
  const longNameString = "  כהן אהברמסקי  ינאי ";
  const longEventString = "לחניכים   עם שם מאד ארוך ";

  clonedModel.childLastName = clonedModel.childLastName + longNameString + " ";
  clonedModel.childEventName =
    clonedModel.childEventName + longEventString + " ";
  clonedModel.parentEventName =
    clonedModel.parentEventName + longEventString + " ";
  clonedModel.childNest = "קן באיזור חיפה עם שם מאד ארוך";

  return clonedModel;
};

export const baseChildDiscountMocks: ChildDiscountModel[] = [
  ...hebLastNames,
  ...hebLastNames,
].map((lastName, intIndex) => {
  const numberOfMembers = Math.floor(Math.random() * 3) + 1;
  const familyHash = `${lastName}${intIndex}${numberOfMembers}`;
  const intFromHash = numberFromString(familyHash, citiesAndNests.length);
  // tslint:disable-next-line:no-bitwise
  const address = ` ${streets[numberFromString(familyHash, streets.length)]} ${
    Math.floor(Math.random() * 90) + 1
  }, ${citiesAndNests[intFromHash]}`;
  const discountStatus = (dindex: number) => {
    if (dindex === 0) {
      return ChildDiscountStatus.AlreadyHasDiscount;
    } else if (dindex === 1) {
      return ChildDiscountStatus.HasSomeDiscounts;
    }
    return ChildDiscountStatus.canAddDiscount;
  };

  const child: ChildDiscountModel = {
    id: numberFromString(familyHash, 100000) + intIndex,
    firstName: getRandomMemberFromString(familyHash, firstNames),
    lastName,
    discountEvents: [],
    address,
    nest: citiesAndNests[intFromHash],
    layer: layers[Math.floor(Math.random() * (layers.length - 4))],
    israeliId: Math.floor(Math.random() * 1000000000).toString(),
    childStatus: discountStatus(intIndex % 3),
  };

  if (intIndex === 1) {
    // return addLongStringsToBaseDiscountModel(discounts);
  }
  return child;
});

export const mockAddChildrenEventStatusFromPricing = (
  child: ChildDiscountModel,
  pricing: ChildEvent[]
) => {
  const newChildModel = { ...child };
  newChildModel.discountEvents = pricing.map((p: ChildEvent) => {
    return {
      childEventId: p.childEventId.toString(),
      hasDiscount: false,
      currentPrice: p.childEventPrice,
      existingDiscount: 0,
    };
  });
  if (newChildModel.childStatus === ChildDiscountStatus.AlreadyHasDiscount) {
    newChildModel.discountEvents = newChildModel.discountEvents.map((d) => ({
      ...d,
      hasDiscount: true,
      existingDiscount: d.currentPrice - Math.floor(d.currentPrice / 4),
    }));
  } else if (
    newChildModel.childStatus === ChildDiscountStatus.HasSomeDiscounts
  ) {
    newChildModel.discountEvents = newChildModel.discountEvents.map(
      (d, indexD) => {
        if (indexD === 0 || Math.random() > 0.6) {
          return d;
        }
        return {
          ...d,
          hasDiscount: true,
          existingDiscount: d.currentPrice - Math.floor(d.currentPrice / 4),
        };
      }
    );
  }
  return newChildModel;
};



// WEBPACK FOOTER //
// ./src/app/admin/discounts/mock/baseChildDiscount.mock.ts